export default "//cloud.imgsmail.ru/cloud.mail.ru/179961/img/build/empty-state/album.png";